import { requestJson, requestBlob, assertOk} from "./storeApi"


export async function fetchCustomers() {
    const { response, payload } = await requestJson("/customers", {
        method: "GET",
        credentials: "include",
    });
    return assertOk(response, payload, "Failed to load customers");
}

export async function fetchOrderReceipt(orderId) {
    return requestBlob(`/checkout/receipt/${orderId}`, "Failed to load receipt");
}